const colors = ['#c97a3b', '#2063f9', '#8a9721', '#5627a5', '#8091c7', '#a11811', '#05bb2b', '#cf01bd', '#e7c8c2', '#a11811']
const hexadecimalAlhabetic = ['a', 'b', 'c', 'd', 'e', 'f'];
const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

/**
 * Función para pasar un color en formato hexadecimal a rgba, sirve para el 
 * chart tipo radar
 * @param hex El valor hexadecimal del color a transformar
 * 
 */
const generarColorRadar = (hex: string) => {
    try {
        const r = hex.substring(1, 3);
        const g = hex.substring(3, 5);
        const b = hex.substring(5, 7);
        const backgroundColor = `rgba(${hexToDecimal(r)},${hexToDecimal(g)},${hexToDecimal(b)},0.2)`
        const borderColor = `rgba(${hexToDecimal(r)},${hexToDecimal(g)},${hexToDecimal(b)},1)`
        return {
            backgroundColor,
            borderColor
        };
    } catch (err) {
        return {
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgba(179,181,198,1)',
        }
    }
}

const hexToDecimal = (hex: string) => {
    try {
        return alphaHexToDec(hex[0], 16) + alphaHexToDec(hex[1], 1);
    } catch (err) {
        console.log('Error en hexToDecimal - ', err);
        return 0;
    }
}

const alphaHexToDec = (alphaHex: string, factor: number) => {
    let number;
    const alphaIndex = hexadecimalAlhabetic.indexOf(alphaHex);
    try {
        if (alphaIndex >= 0) {
            number = factor * (alphaIndex + 10);
        } else {
            number = factor * (+alphaHex);
        }
        return number;
    } catch (err) {
        console.log(err);
        return 0;
    }
}

const generarDatosPieServicios = (servicios: any[]) => {
    const labels: any[] = [];
    const cantidades: any[] = [];
    servicios.forEach((serv) => {
        labels.push(serv.servicio.nombre);
        cantidades.push(serv.cantidad);
    })
    const datasets = [
        {
            data: [...cantidades],
            backgroundColor: [...colors],
            hoverBackgroundColor: [...colors]
        }
    ];

    return { labels, datasets }
}

const generarDatosRadar = (densidadServicios: any) => {
    const labels = densidadServicios.nombresServicios;
    const datasets: any[] = [];
    densidadServicios.datos.forEach((elem: any, index: number) => {
        const valores: any[] = [];
        elem.servicios.forEach((serv: any) => {
            valores.push(serv.cantidad);
        })
        const coloresRadar = generarColorRadar(colors[index]);
        datasets.push({
            label: elem.nombreTipoVehiculo,
            backgroundColor: coloresRadar.backgroundColor,
            borderColor: coloresRadar.borderColor,
            pointBackgroundColor: coloresRadar.backgroundColor,
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: coloresRadar.backgroundColor,
            data: valores
        })
    })
    return { labels, datasets };
}

const generarDatosBarras = (dashboardDias: any) => {
    const { serieServicios, datos } = dashboardDias;
    const datasets: any[] = [];
    serieServicios.forEach((serv: any, indexServ: number) => {
        const data: any[] = [];
        diasSemana.forEach((dia: any, indexDia: number) => {
            const foundDatos = datos.find((elem: any) => elem.indexDia === indexDia);
            if (foundDatos) {
                data.push(foundDatos.serviciosDia[indexServ].cantidad);
            } else {
                data.push(0);
            }
        })
        datasets.push({
            label: serv.nombre,
            backgroundColor: colors[indexServ],
            data
        })
    })
    const barsData = {
        labels: diasSemana,
        datasets
    }
    return barsData;
}

export default {
    generarDatosPieServicios, generarDatosRadar,
    generarDatosBarras, diasSemana
};